import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import {
  convertUTCDateToLocalDate,
  formatDateddMMyyyy
} from 'helpers/dateHelper';
import moment from 'moment';
import UsersInCellWidget from 'components/common/users/UsersInCellWidget';
const NewCustTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  handleClickRow,
  onPageSizeChange
}) => {
  const columns = useMemo(
    () => [
      {
        accessor: 'id',
        Header: 'ID',
        isVisible: false
      },
      {
        accessor: 'customerName',
        Header: 'Customer Name'
      },
      {
        accessor: 'wx',
        Header: 'Did You Open This calendar Month',
        Cell: rowData => {
          const { cusCreatedOnEva } = rowData.row.original;
          if (!cusCreatedOnEva) return '';

          const localDate = moment.utc(cusCreatedOnEva).local();
          const now = moment();

          return localDate.isSame(now, 'month') && localDate.isSame(now, 'year')
            ? 'Y'
            : '';
        }
      },
      {
        accessor: '#',
        Header: 'Visit Last Week',
        Cell: rowData => {
          const { lastVisitDate } = rowData.row.original;
          if (!lastVisitDate) return '';

          const localDate = moment.utc(lastVisitDate).local();
          const now = moment();
          const lastWeekStart = now
            .clone()
            .subtract(1, 'week')
            .startOf('isoWeek');
          const lastWeekEnd = now.clone().subtract(1, 'week').endOf('isoWeek');

          return localDate.isBetween(lastWeekStart, lastWeekEnd, null, '[]')
            ? 'Y'
            : '';
        }
      },
      {
        accessor: 'lastVisitDate',
        Header: 'Last Visit',
        Cell: rowData => {
          const { lastVisitDate } = rowData.row.original;
          const date = convertUTCDateToLocalDate(lastVisitDate);
          return formatDateddMMyyyy(date);
        }
      },
      {
        accessor: 'a',
        Header: 'Last Communicate Date',
        Cell: rowData => {
          const { lastVisitDate } = rowData.row.original;
          const date = convertUTCDateToLocalDate(lastVisitDate);
          return formatDateddMMyyyy(date);
        }
      },
      {
        accessor: '123',
        Header: 'Previous Communicate Date 1',
        Cell: rowData => {
          const { lastVisitDate } = rowData.row.original;
          const date = convertUTCDateToLocalDate(lastVisitDate);
          return formatDateddMMyyyy(date);
        }
      },
      {
        accessor: 'saleUserId',
        Header: 'Account Manager',
        Cell: rowData => {
          const { saleUserId } = rowData.row.original;
          return (
            <UsersInCellWidget usersText={saleUserId?.toString()} showName />
          );
        }
      }
    ],
    []
  );

  return (
    <>
      <PartialTable
        data={data}
        columns={columns}
        paging={paging}
        total={total}
        nextPage={nextPage}
        previousPage={previousPage}
        gotoPage={gotoPage}
        onPageSizeChange={onPageSizeChange}
        handleClickRow={handleClickRow}
        textAlign=""
      />
    </>
  );
};

NewCustTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleClickRow: PropTypes.func
};

export default NewCustTable;
